export type SessionAccount = {
  name: string;
  role: string;
  credits?: number;
  isAdmin: boolean;
};

type SessionFetch = (
  input: RequestInfo | URL,
  init?: RequestInit,
) => Promise<Response>;

type FetchSessionAccountOptions = {
  fetcher?: SessionFetch;
  retryDelaysMs?: readonly number[];
};

export function normalizeSessionAccount(payload: unknown): SessionAccount | null {
  const record = payload && typeof payload === "object" ? payload as { user?: unknown } : {};
  const user = record.user && typeof record.user === "object"
    ? record.user as { username?: unknown; isAdmin?: unknown; is_admin?: unknown; credits?: unknown }
    : null;
  const name = typeof user?.username === "string" ? user.username.trim() : "";
  if (!name) return null;
  const isAdmin = user?.isAdmin === true || user?.is_admin === true || user?.is_admin === 1;
  const credits = typeof user?.credits === "number" && Number.isFinite(user.credits)
    ? user.credits
    : undefined;
  return {
    name,
    role: isAdmin ? "管理员" : "星链成员",
    credits,
    isAdmin,
  };
}

export async function fetchSessionAccount(
  endpoint: string,
  {
    fetcher = fetch,
    retryDelaysMs = [0],
  }: FetchSessionAccountOptions = {},
): Promise<SessionAccount | null> {
  for (const delay of retryDelaysMs) {
    if (delay > 0) {
      await new Promise<void>((resolve) => globalThis.setTimeout(resolve, delay));
    }
    try {
      const response = await fetcher(endpoint, {
        credentials: "same-origin",
        cache: "no-store",
      });
      const account = response.ok
        ? normalizeSessionAccount(await response.json())
        : null;
      if (account) return account;
    } catch {
      // A delegated login may still be replacing the local app session.
    }
  }
  return null;
}
